import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { forwardRef } from 'react';

const BuildingsIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  const { color, ...otherProps } = props;

  return (
    <SvgIcon ref={ref} viewBox="0 0 20 20" {...otherProps}>
      <path
        d="M17.5002 16.6667H19.1668V18.3333H0.833496V16.6667H2.50016V2.5C2.50016 2.03977 2.87326 1.66667 3.3335 1.66667H16.6668C17.1271 1.66667 17.5002 2.03977 17.5002 2.5V16.6667ZM15.8335 16.6667V3.33333H4.16683V16.6667H15.8335ZM6.66683 9.16667H9.16683V10.8333H6.66683V9.16667ZM6.66683 5.83333H9.16683V7.5H6.66683V5.83333ZM6.66683 12.5H9.16683V14.1667H6.66683V12.5ZM10.8335 12.5H13.3335V14.1667H10.8335V12.5ZM10.8335 9.16667H13.3335V10.8333H10.8335V9.16667ZM10.8335 5.83333H13.3335V7.5H10.8335V5.83333Z"
        fill={color}
      />
    </SvgIcon>
  );
});

export default BuildingsIcon;
